import { useEffect } from 'react';
import { Popover } from 'bootstrap';

export default function InfoDetails({ text, title = 'Info', icon = 'fe fe-info', className }) {
  useEffect(() => {
    const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');

    popovers.forEach((popover) => {
      new Popover(popover);
    });
  }, []);

  return (
    <button className={`btn btn-link p-0 ${className}`} href="#" title={title} data-bs-toggle="popover" data-bs-content={text}>
      <i className={icon} />
    </button>
  );
}
